module.exports = __webpack_public_path__ + "static/img/wdd.9c81acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wdd.png
// module id = ATsy
// module chunks = 1